import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultarEstadoCuenta_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "consultarEstadoCuenta",
    rutaEndPoint: "/EnterpriseServices/Brm/Factura/consultarEstadoCuenta",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface ConsultarEstadoCuenta_Entrada {
  consultaEstadoDeCuenta_Entrada: ConsultaEstadoDeCuentaEntrada;
}

export function builtConsultarEstadoCuenta_Entrada(
  p_consultaEstadoDeCuenta_Entrada: ConsultaEstadoDeCuentaEntrada
) {
  var retorno: ConsultarEstadoCuenta_Entrada = {
    consultaEstadoDeCuenta_Entrada: p_consultaEstadoDeCuenta_Entrada,
  };

  return retorno;
}

export interface ConsultaEstadoDeCuentaEntrada {
  CABECERA: Cabecera;
  NUMERO_FACTURA: string;
}

export function builtConsultaEstadoDeCuentaEntrada(
  p_CABECERA: Cabecera,
  p_NUMERO_FACTURA: string
) {
  var retorno: ConsultaEstadoDeCuentaEntrada = {
    CABECERA: p_CABECERA,
    NUMERO_FACTURA: p_NUMERO_FACTURA,
  };

  return retorno;
}

export interface Cabecera {
  OPERACION: string;
  APLICATIVO: string;
  PARAMETRO: Parametro[];
}

export function builtCabecera(
  p_OPERACION: string,
  p_APLICATIVO: string,
  p_PARAMETRO: Parametro[]
) {
  var retorno: Cabecera = {
    OPERACION: p_OPERACION,
    APLICATIVO: p_APLICATIVO,
    PARAMETRO: p_PARAMETRO,
  };

  return retorno;
}

export interface Parametro {
  NOMBRE: string;
  VALOR: string;
}

export function builtParametro(p_NOMBRE: string, p_VALOR: string) {
  var retorno: Parametro = {
    NOMBRE: p_NOMBRE,
    VALOR: p_VALOR,
  };

  return retorno;
}

//SALIDA

export interface ConsultarEstadoCuenta_Salida {
  consultaEstadoDeCuenta_Salida: ConsultaEstadoDeCuentaSalida;
}

export interface ConsultaEstadoDeCuentaSalida {
  CABECERA: Cabeceras;
  FACTURA_FORMATEADA: string;
}

export interface Cabeceras {
  COD_ERROR: string;
  MSG_ERROR: string;
}

export type ConsultarEstadoCuenta_Respuesta = EncabezadoRespuestaInterna &
ConsultarEstadoCuenta_Salida;
